import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: ${vars.sectionPadding};
	background-color: ${vars.colorGreen};

	.headline {
		font-size: 1.7em;
		font-weight: 700;
		color: #262626;
		text-align: center;
		margin-bottom: 1.4em;
	}

	.grouped-stages {
		display: flex;
		justify-content: space-between;
		align-items: stretch;
		max-width: 1140px;
		overflow-y: hidden;
		overflow-x: auto;
		gap: 4em;
		padding: 2em 0 0 2em;
		transform: translateX(-2em);

		&::-webkit-scrollbar-track {
			display: none;
		}
		&::-webkit-scrollbar {
			display: none;
		}
		&::-webkit-scrollbar-thumb {
			display: none;
		}

		.stage-container {
			width: 100%;
			max-width: 32%;

			.stage-title {
				position: relative;
				font-size: 1.1em;
				font-weight: 600;
				letter-spacing: 4px;
				text-align: center;
				text-transform: uppercase;
                padding: 0.25em 0em;
                margin-bottom: 1em;
				box-shadow: 0px 3px 6px #00000029;
				border-radius: 5px;
                background-color: ${vars.colorWhite};
                color: ${vars.colorTextGray};

				&__circle {
					position: absolute;
                    bottom: 50%;
					left: -0.8em;
                    transform: translateY(50%);
					height: 2.5em;
					width: 2.5em;
					border-radius: 100%;
					box-shadow: 0px 3px 6px #00000029;
                    background-color: ${vars.colorWhite};
                    display: flex;
					place-content: center;
					place-items: center;
				}
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {

		.layout-container {
			width: 100%;
		}

		.grouped-stages {
			padding: 1em 0 2em 3em;
			gap: 3em;
			width: 100%;
			transform: translateX(0px);

			.stage-container {
				min-width: 270px;
				max-width: 100%;

				&:last-child {
					padding-right: 2em;
				}
			}
		}
	}
`;
